import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    user: null,
    isHydrated: false,
    sessionError: null,
  }),
  getters: {
    hasPermission: (state) => (perms) => {
      if (!state.user?.permissions) return false

      // Se for string → transforma em array
      const list = Array.isArray(perms) ? perms : [perms]

      // Verifica se o utilizador tem pelo menos uma das permissões
      return list.some(p => state.user.permissions.includes(p))
    },
    // NEXUS-148 - Alice Serina - 21/10/2026
    // added additional method in case future features explicitely require
    // a combination of permissions
    hasAllPermissions: (state) => (perms) => {
      if (!state.user?.permissions) return false

      // Se for string → transforma em array
      const list = Array.isArray(perms) ? perms : [perms]
      // this will retun true if `list` is empty
      return list.every((p) => state.user.permissions.includes(p));
    },
    hasRole: (state) => (roles) => {
      if (!state.user?.roles) return false

      // Se for string → converte em array
      const list = Array.isArray(roles) ? roles : [roles]

      // Verifica se existe interseção
      return state.user.roles.some(role => list.includes(role))
    },
    belongsToDepartments: (state) => (departmentIdsToCheck) => {
      if(!state?.user?.departments) return false;

      let userDepartmentIds = Array.isArray(state?.user?.departments)
                          ? state.user.departments
                          : [];
      userDepartmentIds = userDepartmentIds.map((dep) => dep?.id).filter(Boolean);
      userDepartmentIds = new Set(userDepartmentIds);

      departmentIdsToCheck = Array.isArray(departmentIdsToCheck) ? departmentIdsToCheck : [departmentIdsToCheck];

      departmentIdsToCheck = new Set(departmentIdsToCheck);

      return [...userDepartmentIds].some((departmentId) =>
          departmentIdsToCheck.has(departmentId),
      );


    }
  },
  actions: {
    // NEXUS-148 - Alice Serina - 21/10/2026
    // introducing actions (methods) so that the vue router can access the 
    // user's session information
    setUser(user) {
      this.user = user;
      this.isHydrated = true;
      this.sessionError = null;
    },
    clearUser() {
      this.user = null;
      this.isHydrated = true;
      this.sessionError = null;
    },
    // NEXUS-148 - Alice Serina - 21/10/2026
    // since the session information is hydrated outsite of Layout.vue
    // the sessionError property will need to be filled here
    setSessionError(error) {
      this.user = null;
      this.isHydrated = true;
      this.sessionError = error;
    }
  }
})
